<div class="main-container">
  <form [formGroup]="dispatchDeviceAddForm" novalidate>
    <div class="page-header">
      <div class="routing-buttons">
        <div
          class="action-button back-button"
          (click)="navigateBack()"
          tabindex="0"
          (keydown.enter)="navigateBack()"
        >
          <mat-icon class="icon back-icon">arrow_back</mat-icon>
        </div>
        <div
          class="action-button reload-button"
          (click)="ngOnInit()"
          tabindex="0"
          (keydown.enter)="ngOnInit()"
        >
          <mat-icon class="icon reload-icon">refresh</mat-icon>
        </div>
        @if (dispatchDeviceCreate) {
          <span class="page-title">Create Dispatched Device</span>
        }
        @if (dispatchDeviceUpdate) {
          <span class="page-title">View Dispatched Device</span>
        }
      </div>
    </div>

    <div class="component-container">
      <!-- Component Header Section -->
      <div class="component-header">
        @if (dispatchDeviceCreate) {
          <h6 class="component-title">Add Dispatch Devices</h6>
        }
        @if (dispatchDeviceUpdate) {
          <h6 class="component-title">Dispatched Device Details</h6>
          <div class="component-actions">
            <button
              class="primary-button"
              [disabled]="dispatchDeviceList.length === 0"
              (click)="exportDispatchBatchToExcel(batchId)"
              value="excel"
            >
              Export Uploaded Devices<mat-icon class="btn-icon"
                >download</mat-icon
              >
            </button>
            <app-common-search
              (searchSubmit)="onSearchInputChange($event)"
            ></app-common-search>
          </div>
        }
      </div>

      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      @if (dispatchDeviceCreate) {
        <!-- Component Body Section -->
        <div class="component-body">
          <div class="form-section">
            <!-- UIN -->
            <div class="form-group">
              <label for="stateName" class="form-label">UIN Start</label>
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>UIN Start</mat-label>
                <input
                  id="startUin"
                  placeholder="UIN Start"
                  formControlName="startUin"
                  matInput
                  type="text"
                  required
                />
                @if (
                  dispatchDeviceAddForm.controls['startUin'].touched &&
                  dispatchDeviceAddForm.controls['startUin'].errors
                    ?.lengthCheckValidator
                ) {
                  <mat-error>
                    {{
                      dispatchDeviceAddForm.controls['startUin'].errors
                        ?.lengthCheckValidator
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>

            <div class="form-group">
              <label for="stateName" class="form-label">UIN End</label>
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>UIN End</mat-label>
                <input
                  id="endUin"
                  placeholder="UIN End"
                  formControlName="endUin"
                  matInput
                  type="text"
                  required
                />
                @if (
                  dispatchDeviceAddForm.controls['endUin'].touched &&
                  dispatchDeviceAddForm.controls['endUin'].errors
                    ?.lengthCheckValidator
                ) {
                  <mat-error>
                    {{
                      dispatchDeviceAddForm.controls['endUin'].errors
                        ?.lengthCheckValidator
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>

            <div class="form-group">
              <label for="type" class="form-label">Customer Name</label>
              <mat-form-field appearance="outline">
                <mat-label>Customer Name</mat-label>
                <mat-select formControlName="customerName" required>
                  @for (customer of customerList; track customer) {
                    <mat-option [value]="customer.customerName">
                      {{ customer.customerName }}
                    </mat-option>
                  }
                </mat-select>
                @if (
                  dispatchDeviceAddForm.controls['customerName'].touched &&
                  dispatchDeviceAddForm.controls['customerName'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      dispatchDeviceAddForm.controls['customerName'].errors
                        ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>

            <div class="form-group">
              <label for="portOne" class="form-label">Dispatch Date</label>
              <mat-form-field appearance="outline">
                <mat-label>Dispatch Date</mat-label>
                <input
                  id="dispatchDate"
                  placeholder="Dispatch Date"
                  formControlName="dispatchDate"
                  required
                  matInput
                  [matDatepicker]="dispatchDeviceDatePicker1"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="dispatchDeviceDatePicker1"
                ></mat-datepicker-toggle>
                <mat-datepicker #dispatchDeviceDatePicker1></mat-datepicker>
                <!-- @if (
                dispatchDeviceAddForm.controls['bootstrapExpDate'].touched &&
                dispatchDeviceAddForm.controls['bootstrapExpDate'].errors
                  ?.isValidDate
              ) {
                <mat-error>
                  <span>{{
                    dispatchDeviceAddForm.controls['bootstrapExpDate'].errors
                      ?.isValidDate
                  }}</span>
                </mat-error>
              } -->
              </mat-form-field>
            </div>

            @if (showDeviceDetails) {
              <div class="form-group">
                <label for="totalCount" class="form-label">Total Count</label>
                <mat-form-field class="form-field" appearance="outline">
                  <mat-label>Total Count</mat-label>
                  <input
                    matInput
                    type="number"
                    [value]="batchTotalItems"
                    readonly
                  />
                </mat-form-field>
              </div>
            }
          </div>
        </div>

        <div class="component-separator"></div>

        <div class="component-footer">
          <div class="button-group">
            @if (dispatchDeviceCreate) {
              <button
                class="submit-button"
                (click)="showDetails()"
                [disabled]="this.dispatchDeviceAddForm.invalid"
              >
                Show Details <mat-icon class="btn-icon">visibility</mat-icon>
              </button>

              <button
                class="submit-button"
                (click)="validateFormSave()"
                [disabled]="this.dispatchDeviceAddForm.invalid"
              >
                Submit <mat-icon class="btn-icon">check_circle</mat-icon>
              </button>
            }
            <!-- @if (dispatchDeviceUpdate) {
            <button class="edit-button" (click)="validateFormUpdate()">
              Update <mat-icon class="btn-icon">edit</mat-icon>
            </button>
          } -->
          </div>
        </div>
      }

      @if (dispatchDeviceCreate && showDeviceDetails) {
        <div class="component-container">
          <div class="component-body">
            <div class="component-header">
              <h6 class="component-title">Batch Device List</h6>
            </div>

            <div class="component-separator"></div>

            <table>
              <thead>
                <tr>
                  <th>UIN</th>
                  <th>IMEI</th>
                  <th>ICCID</th>
                  <th>Model Name</th>
                </tr>
              </thead>

              @if (dispatchDeviceDetailsList.length > 0) {
                <tbody>
                  @for (item of dispatchDeviceDetailsList; track item.uid) {
                    <tr>
                      <td>{{ item.uid }}</td>
                      <td>{{ item.imei }}</td>
                      <td>{{ item.iccid }}</td>
                      <td>{{ item.modelName }}</td>
                    </tr>
                  }
                </tbody>
              }

              @if (dispatchDeviceDetailsList.length === 0) {
                <tbody>
                  <tr>
                    <td colspan="5">
                      <img
                        loading="lazy"
                        class="no-data-img"
                        src="../../assets/dataNotFound.jpg"
                        alt="No Data Found"
                      />
                    </td>
                  </tr>
                </tbody>
              }
            </table>
          </div>

          <div class="component-separator"></div>
          <div class="component-footer">
            @if (dispatchDeviceDetailsList.length > 0) {
              <app-common-component-pagination
                [totalItems]="batchTotalItems"
                [pageSize]="batchPageSize"
                (pageChange)="onBatchPageChange($event)"
                (sizeChange)="onBatchSizeChange($event)"
              >
              </app-common-component-pagination>
            }
          </div>
        </div>
      }

      <!-- View -->
      @if (dispatchDeviceUpdate) {
        <div class="component-body">
          <table>
            <thead>
              <tr>
                <th>UIN</th>
                <th>IMEI</th>
                <th>ICCID</th>
                <th>Model Name</th>
                <th>Customer Name</th>
                <th>Dispatch Date</th>
              </tr>
            </thead>
            @if (dispatchDeviceList.length > 0) {
              <tbody>
                @for (item of dispatchDeviceList; track item) {
                  <tr>
                    <td>{{ item.uid }}</td>
                    <td>{{ item.imei }}</td>
                    <td>{{ item.iccid }}</td>
                    <td>{{ item.modelName }}</td>
                    <td>{{ item.customerName }}</td>
                    <td>{{ item.dispatchDate | date: 'dd/MM/yyyy' }}</td>
                  </tr>
                }
              </tbody>
            }
            @if (dispatchDeviceList.length === 0) {
              <tbody>
                <tr>
                  <td colspan="7">
                    <img
                      loading="lazy"
                      class="no-data-img"
                      src="../../assets/dataNotFound.jpg"
                      alt="No Data Found"
                    />
                  </td>
                </tr>
              </tbody>
            }
          </table>
        </div>

        <div class="component-separator"></div>
        <div class="component-footer">
          @if (dispatchDeviceList.length > 0) {
            <app-common-component-pagination
              [totalItems]="totalItems"
              [pageSize]="pageSize"
              (pageChange)="onPageChange($event)"
              (sizeChange)="onSizeChange($event)"
            >
            </app-common-component-pagination>
          }
        </div>
      }
    </div>
  </form>
</div>
